module.exports = __webpack_public_path__ + "img/nav_2_10.40f2bcbf.png";